<ion-header no-border>
  <ion-toolbar>
    <ion-title class="text-center color-dark" data-cy="editMicrosite-form-title">Edit {{inputLabel}}</ion-title>

    <ion-buttons slot="start">
      <ion-button ion-button (click)="dismiss()" data-cy="editMicrosite-toolbar-dismiss">
        <ion-icon color="dark" class="modal-close" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>

    <ion-buttons slot="end">
      <ion-button class="toolbarButton" color="primary" [disabled]="isDisabled" ion-button (click)="done()"
        data-cy="editMicrosite-toolbar-save">
        Save
      </ion-button>
    </ion-buttons>

  </ion-toolbar>
</ion-header>

<ion-content class="app-edit-microsite" padding>
  <ion-item lines="none">
    <ion-label position="stacked" data-cy="editMicrosite-form-price-lbl">Price</ion-label>
    <ion-input mode="ios" #priceInputID id="priceInputID" autocomplete="off" [(ngModel)]="inputData.price" myNumberOnly
      type="number" pattern="[0-9]*" data-cy="editMicrosite-form-price-input" (keyup.enter)="goto('txtBedrooms')">
    </ion-input>
  </ion-item>

  <ion-item lines="none">
    <ion-label position="stacked" data-cy="editMicrosite-form-bedrooms-lbl">Bedrooms</ion-label>
    <ion-input mode="ios" #txtBedrooms [(ngModel)]="inputData.beds" autocomplete="off" myNumberOnly type="number"
      pattern="[0-9]*" (keyup.enter)="goto('txtBathrooms')" data-cy="editMicrosite-form-bedrooms-input"></ion-input>
  </ion-item>

  <ion-item lines="none">
    <ion-label position="stacked" data-cy="editMicrosite-form-bathrooms-lbl">Bathrooms</ion-label>
    <ion-input mode="ios" #txtBathrooms [(ngModel)]="inputData.baths" autocomplete="off" type="number" myNumberOnly
      decimal="true" pattern="[0-9]+([.][0-9]+)?" step="0.25" (keyup.enter)="goto('txtSquareFeet')"
      data-cy="editMicrosite-form-bathrooms-input"></ion-input>
  </ion-item>

  <ion-item lines="none">
    <ion-label position="stacked" data-cy="editMicrosite-form-sqFeet-lbl">Square Feet</ion-label>
    <ion-input mode="ios" #txtSquareFeet [(ngModel)]="inputData.squareFootage" autocomplete="off" type="number"
      myNumberOnly (keyup.enter)="goto('##save##')" data-cy="editMicrosite-form-sqFeet-input"></ion-input>
  </ion-item>

  <!-- 
  <ion-item >
    <ion-label position="stacked">Description</ion-label>
    <ion-input mode="ios" [(ngModel)]="inputData.description" type="text"></ion-input>
  </ion-item>

  <ion-item style="margin-top:10px;" >
    <ion-label>Sale Status</ion-label>
    <ion-select  [(ngModel)]="inputData.saleStatus" interface="popover">
      <ion-select-option value="Closed Sale">Closed Sale</ion-select-option>
      <ion-select-option value="Coming Soon">Coming Soon</ion-select-option>
      <ion-select-option value="Contingent">Contingent</ion-select-option>
      <ion-select-option value="For Sale">For Sale</ion-select-option>
      <ion-select-option value="For Lease">For Lease</ion-select-option>
      <ion-select-option value="Pending">Pending</ion-select-option>
    </ion-select>
  </ion-item>
-->

  <div [style.padding-bottom.px]="utils.keyboardHeight"></div>
</ion-content>